export default __webpack_public_path__ + "static/media/arrowMediumTop.9d4c57bf.svg";